// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReasoningCreatorVideo-text {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--primary_dark2);
}
.ReasoningCreatorVideo-text .CreatorCardOnHover {
  display: inline-flex;
}
.ReasoningCreatorVideo-text span .blur-text {
  text-shadow: 0 0 5px var(--primary_dark2);
  color: transparent;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ReasoningCreatorVideo/index.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,oBAAA;AAAN;AAIM;EACE,yCAAA;EACA,kBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAFR","sourcesContent":[".ReasoningCreatorVideo {\n  &-text {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 18px;\n    color: var(--primary_dark2);\n\n    .CreatorCardOnHover {\n      display: inline-flex;\n    }\n\n    span {\n      .blur-text {\n        text-shadow: 0 0 5px var(--primary_dark2);\n        color: transparent;\n        user-select: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
